import { render, staticRenderFns } from "./PaymentModal.vue?vue&type=template&id=6c2b281b&"
import script from "./PaymentModal.vue?vue&type=script&lang=js&"
export * from "./PaymentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports